const googlePlacesApiKey = 'AIzaSyBmj9LSvesg3M5cq4ei1sYZhGsxOi7Y0fs';
const projectName = 'Region im Netz';

export default {
    GOOGLE_PLACES_API_KEY: googlePlacesApiKey,
    projectName,
};
